export namespace Home {
  export enum Department {
    SinisterSix = 'Sinister six',
    Avengers = 'The Avengers',
    NoDepart = 'No Department',
  }
  
}